export default __webpack_public_path__ + "static/media/Path 477.27c4e81e.png";